module.exports = __webpack_public_path__ + "static/media/20210801_AKHIRPEKAN_WORDMARK 1.db9166ec.png";